import { useCallback } from 'react'

import { notifications } from '@mantine/notifications'
import { AlertTriangle, Ban, CheckCheck, Info } from 'lucide-react'

interface NotificationOptions {
  autoClose?: number | false
  color?: string
  icon?: React.ReactNode
  loading?: boolean
  message: string | React.ReactNode
  title: string
}

interface NotificationReturn {
  showSuccess: (options: NotificationOptions) => void
  showError: (options: NotificationOptions) => void
  showInfo: (options: NotificationOptions) => void
  showWarning: (options: NotificationOptions) => void
  cleanNotifications: () => void
}

export const useNotifications = (): NotificationReturn => {
  const showSuccess = useCallback((options: NotificationOptions) => {
    return notifications.show({
      autoClose: 5000,
      color: 'shalion-green.5',
      icon: <CheckCheck size={16} color='var(--mantine-color-dark-9)' />,
      ...options,
    })
  }, [])

  const showError = useCallback((options: NotificationOptions) => {
    return notifications.show({
      autoClose: 5000,
      color: 'red.5',
      icon: <Ban size={16} color='white' />,
      ...options,
    })
  }, [])

  const showInfo = useCallback((options: NotificationOptions) => {
    return notifications.show({
      autoClose: 5000,
      color: 'blue.5',
      icon: <Info size={16} color='white' />,
      ...options,
    })
  }, [])

  const showWarning = useCallback((options: NotificationOptions) => {
    return notifications.show({
      autoClose: 5000,
      color: 'yellow.5',
      icon: <AlertTriangle size={16} color='white' />,
      ...options,
    })
  }, [])

  const cleanNotifications = useCallback(() => {
    notifications.clean()
  }, [])

  return {
    showSuccess,
    showError,
    showInfo,
    showWarning,
    cleanNotifications,
  }
}
